var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fab",style:(_vm.fab_style + _vm.position_adapted + _vm.small_adapted)},[_c('i',{staticClass:"fal",class:_vm.icon_adapted})])}
var staticRenderFns = []

export { render, staticRenderFns }